module.exports = __webpack_public_path__ + "static/media/Tank_Temperature.255c31ae.svg";